import React from 'react';
import { Box } from '@chakra-ui/react';
import SectionHeading from './section-heading';
import Timeline from './timeline';

export default function Education() {
  const educationList = [
    {
      duration: '2017 – 2021',
      title: 'Computer Engineering',
      subtitle: "King Mongkut's Institute Of Technology Ladkrabang",
      detail: 'GPA 3.36 · Second Class Honors',
    },
    {
      duration: '2004 – 2016',
      title: 'Science and Mathematics Program',
      subtitle: 'Bangkok Christian College',
    },
  ];

  return (
    <Box mt={'90px'}>
      <SectionHeading index="02">Education</SectionHeading>
      <Timeline items={educationList} />
    </Box>
  );
}
